function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.99902 0.5H16C16.4162 0.5 16.7605 0.642345 17.0596 0.941406C17.3585 1.24037 17.5004 1.58404 17.5 1.99902V16C17.5 16.4162 17.3577 16.7605 17.0586 17.0596C16.7596 17.3585 16.416 17.5004 16.001 17.5H2C1.58379 17.5 1.2395 17.3577 0.94043 17.0586C0.641466 16.7596 0.49958 16.416 0.5 16.001V2C0.5 1.5838 0.642345 1.2395 0.941406 0.94043C1.24037 0.641467 1.58404 0.499581 1.99902 0.5Z",
  stroke: "#062F53"
});

var SvgCheckOff = function SvgCheckOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check_off.5abb2150.svg";
export { ForwardRef as ReactComponent };